import React from "react";
import Reveal from "./Reveal";

const PageHero = ({ overline, title, subtitle, image }) => (
  <section className="relative bg-black overflow-hidden">
    {image && (
      <div className="absolute inset-0 z-0">
        <img src={image} alt={title} className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-black/70 to-black/80" />
      </div>
    )}
    <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-12 py-20 md:py-28 text-left">
      <Reveal>
        {overline && (
          <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">{overline}</span>
        )}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-white mt-3 leading-tight">
          {title}
        </h1>
        {subtitle && <p className="text-zinc-300 text-lg md:text-xl mt-5 max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
